module.exports = __webpack_public_path__ + "media/images/icons/country_flags/rw-f87cd918f9cf4421e1099975b5684e78.svg";